import { useEffectOnce } from 'react-use';

import useFetch from '../../hooks/useFetch';
import Api from '../../api';
import useDevicesFilter from '../DevicesPage/hooks/useDevicesFilter';

const useContentCrud = ({
  fetchOnInit = true,
  onAddLinkSuccess,
  onAddFilesSuccess,
}) => {
  const { loading, response: content, onFetch } = useFetch(
    'content',
    Api.CONTENT
  );
  let { onFetch: handleDelete, loading: deleteLoading } = useFetch(
    'content-delete',
    Api.CONTENT_DELETE
  );
  const { onSubmit: handleAddLink } = useFetch(
    'content-add-link',
    Api.CONTENT_ADD_LINK
  );

  const onAddLink = (values) =>
    handleAddLink({
      body: { ...values, duration: 0 },
      onSuccess: onAddLinkSuccess,
    });

  const onDelete = (id, options = {}) => () =>
    handleDelete({
      pathParams: { id },
      method: 'DELETE',
      onSuccess: onFetch,
      onError: () => {},
      ...options,
    });

  const { sort, onSort, sortDevices, onSearch, filter } = useDevicesFilter();

  useEffectOnce(() => {
    if (fetchOnInit) onFetch();
  });

  return {
    onAddLink,
    loading: loading || deleteLoading,
    content: sortDevices(filter(content)),
    sort,
    onSort,
    onSearch,
    onFetch,
    onDelete,
  };
};

export default useContentCrud;
